export const USER_TYPES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  PROFESSIONAL: 'professional',
} as const

export const BARTER_TYPES = {
  GOODS: 'goods',
  SERVICES: 'services',
} as const

export const BARTER_STATUS = {
  OPEN: 'open',
  READY: 'ready',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  CLOSED: 'closed',
  CONFLICT: 'conflict',
} as const

export const BARTER_VISIBILITY = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const

export const REQUEST_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
} as const

export const TRANSACTION_TYPES = {
  PURCHASE: 'purchase',
  WITHDRAWAL: 'withdrawal',
  TRANSFER_IN: 'transfer_in',
  TRANSFER_OUT: 'transfer_out',
  ESCROW_LOCK: 'escrow_lock',
  ESCROW_RELEASE: 'escrow_release',
  SUBSCRIPTION: 'subscription',
  REFUND: 'refund',
} as const

export const TRANSACTION_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled',
} as const

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  CANCELLED: 'cancelled',
} as const

export const TICKET_REASONS = {
  GENERAL: 'general',
  ISSUE: 'issue',
  PAYOUT: 'payout',
  SPONSOR_SUPPORT: 'sponsor support',
} as const

export const TICKET_STATUS = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
} as const

export const COIN_PURCHASE_AMOUNTS = [25, 50, 100, 500, 1000]

export const ALLOWED_FILE_TYPES = ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png', 'gif']

export const MAX_FILE_SIZE_MB = 50

export const STATUS_COLORS: Record<string, string> = {
  open: 'blue',
  ready: 'green',
  in_progress: 'yellow',
  completed: 'green',
  closed: 'gray',
  conflict: 'red',
  pending: 'yellow',
  accepted: 'green',
  rejected: 'red',
  active: 'green',
  inactive: 'gray',
  cancelled: 'red',
  failed: 'red',
}

export const LANGUAGES = ['English', 'Spanish']
